import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Testimonials.css";

function Testimonials() {
  const es_en = useSelector((state) => state.translation);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [direction, setDirection] = useState("next");

  const testimonials = [
    {
      id: 1,
      name: "Álvaro Montalbán (seudónimo)",
      role: es_en ? "Project Manager, IBM" : "Project Manager, IBM",
      text: es_en
        ? "Mario is an exceptional developer. His technical skills and problem-solving abilities exceeded our expectations."
        : "Mario es un desarrollador excepcional. Sus habilidades técnicas y capacidad de resolución superaron nuestras expectativas.",
      avatar: "👨‍💼",
      rating: 5,
    },
    {
      id: 2,
      name: "María López",
      role: es_en ? "CEO, ELECONOR" : "CEO, ELECONOR",
      text: es_en
        ? "Working with Mario transformed our development process. He improved efficiency and mentored our team effectively."
        : "Trabajar con Mario transformó nuestro proceso de desarrollo. Mejoró la eficiencia y mentoró nuestro equipo efectivamente.",
      avatar: "👩‍💼",
      rating: 5,
    },
    {
      id: 3,
      name: "Carlos Rodríguez",
      role: es_en ? "Founder, Tech Startup" : "Fundador, Tech Startup",
      text: es_en
        ? "Mario delivered a complete full-stack solution on time and within budget. Highly recommended for any project."
        : "Mario entregó una solución full-stack completa a tiempo y dentro del presupuesto. Altamente recomendado.",
      avatar: "👨‍💻",
      rating: 5,
    },
  ];

  useEffect(() => {
    if (!isAutoPlay) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setDirection("next");
      setCurrentIndex((current) => (current + 1) % testimonials.length);
    }, 4500);

    return () => window.clearInterval(intervalId);
  }, [isAutoPlay, testimonials.length]);

  const handlePrev = () => {
    setIsAutoPlay(false);
    setDirection("prev");
    setCurrentIndex((current) =>
      current === 0 ? testimonials.length - 1 : current - 1,
    );
  };

  const handleNext = () => {
    setIsAutoPlay(false);
    setDirection("next");
    setCurrentIndex((current) =>
      current === testimonials.length - 1 ? 0 : current + 1,
    );
  };

  const handleDotClick = (idx) => {
    if (idx === currentIndex) {
      return;
    }

    setIsAutoPlay(false);
    setDirection(idx > currentIndex ? "next" : "prev");
    setCurrentIndex(idx);
  };

  const current = testimonials[currentIndex];

  return (
    <section className="testimonials section" id="testimonials">
      <div className="container">
        <h2 className="section__title reveal">
          {es_en ? "What People Say" : "Qué Dicen de Mí"}
        </h2>
        <p className="section__subtitle reveal">
          {es_en
            ? "Feedback from coworkers and clients"
            : "Opiniones de compañeros de trabajo y clientes"}
        </p>

        <div className="testimonials__container reveal">
          <div
            key={`${current.id}-${currentIndex}`}
            className={`testimonials__card testimonials__card--${direction}`}
          >
            <div className="testimonials__header">
              <span className="testimonials__avatar">{current.avatar}</span>
              <div className="testimonials__info">
                <h3 className="testimonials__name">{current.name}</h3>
                <p className="testimonials__role">{current.role}</p>
              </div>
            </div>

            <div className="testimonials__rating">
              {Array.from({ length: current.rating }).map((_, i) => (
                <i key={i} className="uil uil-star"></i>
              ))}
            </div>

            <p className="testimonials__text">"{current.text}"</p>
          </div>

          <div className="testimonials__controls">
            <button
              type="button"
              className="testimonials__btn"
              onClick={handlePrev}
            >
              <i className="uil uil-angle-left"></i>
            </button>
            <span className="testimonials__counter">
              {currentIndex + 1} / {testimonials.length}
            </span>
            <button
              type="button"
              className="testimonials__btn"
              onClick={handleNext}
            >
              <i className="uil uil-angle-right"></i>
            </button>
          </div>

          <div className="testimonials__dots">
            {testimonials.map((_, idx) => (
              <button
                type="button"
                key={idx}
                className={`testimonials__dot ${
                  idx === currentIndex ? "testimonials__dot--active" : ""
                }`}
                onClick={() => handleDotClick(idx)}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
